import React, {useState} from "react";
import classNames from "classnames/bind";

import {Tile} from "../../types/Tile";
import {ReactComponent as MenuIcon} from "../../icons/menu.svg";
import {CancelModal} from "../CancelModal";
import {useStateManager} from "../../utils/useStateManager";
import {Button} from "../Button";

import styles from "./DietanamnezMenu.module.css";

const cx = classNames.bind(styles);

type Props = {
  maxStep: number;
  setStep: (step:number) => void;
  tiles: Tile[];
};

export const DietanamnezMenu: React.FC<Props> = ({maxStep, setStep, tiles}) => {
  const {linkInfo, tokenRegistration} = useStateManager();

  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const clickMenuHandler = (status: boolean) => setIsMenuVisible(status)
  const clickMenuItemHandler = (index: number) => {
    setStep(index);
    setIsMenuVisible(false);
  }

  return (
    <>
      <button
        className={cx("menu__button")}
        onClick={() => clickMenuHandler(true)}
        type="button"
      >
        <MenuIcon width={16} height={16}/>
      </button>
      {isMenuVisible &&
        <div
          className={cx("menu")}
          onClick={() => clickMenuHandler(false)}
        >
          <ul
            className={cx("menu__items")}
            onClick={(e: React.MouseEvent<HTMLUListElement, MouseEvent>) => e.stopPropagation()}
          >
            {linkInfo?.custom?.custom_возможность_принудительного_завершения_опроса_саморегистрации && tokenRegistration &&
              <li
                key={-1}
                className={cx("menu__item")}
              >
                <Button
                  color="white"
                  block
                  size="medium"
                  rounded
                  type="button"
                  onClick={() => setIsModalVisible(true)}
                >
                  Прервать опрос и выйти
                </Button>
              </li>
            }
            {tiles.map((tile, index) =>
              <li
                key={index}
                className={cx("menu__item", {["menu__item--blocked"]: index > maxStep})}
                onClick={() => clickMenuItemHandler(index)}
              >
                <span className={cx("menu__number")}>0{index + 1}</span>
                <p className={cx("menu__text", {["menu__text--blocked"]: index > maxStep})}>{tile.custom_наименование}</p>
              </li>
            )}
          </ul>
          {isModalVisible &&
            <CancelModal
              isOpen={isModalVisible}
              handleClose={() => setIsModalVisible(false)}
            />}
        </div>
      }
    </>
  )
}